import req from '@/service/api';
import Store from '@/store/index';
const key = '/user/';
const user = {
    getAll() {
        return req('GET', key + 'getAll');
    },
    createUser(params) {
        return Store.state.auth.authList.isActer ? req('POSt', key + 'create', params) : false;
    },
    setPwd(params) {
        return req('PUT', key + 'setPwd', params);
    },
    setRoles(params) {
        return Store.state.auth.authList.isActer ? req('PUT', key + 'setRoles', params) : false;
    },
    turnOnOff(params) {
        return Store.state.auth.authList.isActer ? req('PUT', key + 'turnOnOff', params) : false;
    },
    resetPwd(params) {
        return Store.state.auth.authList.isActer ? req('PUT', key + 'resetPwd', params) : false;
    }
};
export default user;
